import { render, staticRenderFns } from "./AuthorityGroupModifyBasic.vue?vue&type=template&id=a8426f46&"
import script from "./AuthorityGroupModifyBasic.vue?vue&type=script&lang=ts&"
export * from "./AuthorityGroupModifyBasic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports